import { BrowserRouter as Router, Route, Switch } from "react-router-dom"

// Components
import Scroll from "./components/Scroll"
import Header from "./components/Header"
import Showcase from "./components/Showcase"
import Services from "./components/Services"
import ContactForm from "./components/ContactForm"
import Footer from "./components/Footer"

// Pages
import ServicesPage from "./pages/Services"
import GetStarted from "./pages/GetStarted"

function App() {
  return (
    <Router>
      <Scroll />
      <Header />
      <Switch>
        <Route path="/" exact>
          <Showcase />
          <Services />
          <ContactForm />
        </Route>
        <Route path="/services">
          <ServicesPage />
        </Route>
        <Route path="/get-started">
          <GetStarted />
        </Route>
      </Switch>
      <Footer />
    </Router>
  )
}

export default App
